module.exports = __webpack_public_path__ + "img/PV_1.eccbc3f5.png";